import { render, staticRenderFns } from "./DefinicionCompras.vue?vue&type=template&id=621e5e41&"
import script from "./DefinicionCompras.vue?vue&type=script&lang=js&"
export * from "./DefinicionCompras.vue?vue&type=script&lang=js&"
import style0 from "./DefinicionCompras.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports